import styled from 'styled-components'

export const NotificationList = styled.div`
  max-height: 65vh;
  padding: var(--spacer-2) 0;
  overflow-y: auto;
`

NotificationList.displayName = 'NotificationList'
